import './App.css';
import Features from './Components/Features';
import Footer from './Components/Footer';
import Landing from './Components/Landing';
import Navbar from './Components/Navbar';
import Platforms from './Components/Platforms';
import Pricing from './Components/Pricing';
import Uses from './Components/Uses';

function App() {
  return (
    <div>
      <Navbar />
      <div className='main'>
        <Landing />
        <Features id="product" />
        <Uses id="features" />
        <Platforms id="platforms" />
        <Pricing id="pricing" />
        <Footer />
      </div>
    </div>
  );
}

export default App;
